var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 120,
    viewBox: "0 0 105 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 5.625C58.125 2.50781 55.6172 0 52.5 0C49.3828 0 46.875 2.50781 46.875 5.625V13.125H39.375C36.2578 13.125 33.75 15.6328 33.75 18.75C33.75 21.8672 36.2578 24.375 39.375 24.375H46.875V33.75H13.9688C6.25781 33.75 0 40.0078 0 47.7188C0 49.6406 0.398438 51.5391 1.14844 53.2969L13.8516 82.5H26.1094L11.4844 48.7969C11.3438 48.4453 11.25 48.0938 11.25 47.7188C11.25 46.2188 12.4688 45 13.9688 45H52.5H91.0312C92.5312 45 93.75 46.2188 93.75 47.7188C93.75 48.0938 93.6797 48.4688 93.5156 48.7969L78.8672 82.5H91.125L103.828 53.2969C104.602 51.5391 104.977 49.6406 104.977 47.7188C104.977 40.0078 98.7188 33.75 91.0078 33.75H58.125V24.375H65.625C68.7422 24.375 71.25 21.8672 71.25 18.75C71.25 15.6328 68.7422 13.125 65.625 13.125H58.125V5.625ZM23.7188 101.25H81.2812L85.1719 108.75H19.8516L23.7422 101.25H23.7188ZM90.2109 94.0547C88.9219 91.5703 86.3438 90 83.5547 90H21.4453C18.6328 90 16.0781 91.5703 14.7891 94.0547L8.57812 106.055C7.875 107.414 7.5 108.914 7.5 110.438C7.5 115.734 11.7656 120 17.0625 120H87.9375C93.2109 120 97.5 115.734 97.5 110.438C97.5 108.914 97.125 107.414 96.4219 106.055L90.2109 94.0547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingLogoBlack);
export default __webpack_public_path__ + "static/media/King Logo Black.dbfd9c429489571f3d908899ec4b517c.svg";
export { ForwardRef as ReactComponent };